// document.addEventListener('DOMContentLoaded', function() {
//     document.getElementById("contactForm").addEventListener("submit", function(event) {
//         event.preventDefault();
//
//         let constraints = {
//             full_name: {
//                 presence: {allowEmpty: false, message: "is required"}
//             },
//             organization: {
//                 presence: {allowEmpty: false, message: "is required"}
//             },
//             email: {
//                 presence: {allowEmpty: false, message: "is required"},
//                 email: { message: "is not valid" }
//             },
//             tel: {
//                 presence: {allowEmpty: false, message: "is required"},
//                 format: {
//                     pattern: "\\d+",
//                     message: "must be contain only numbers"
//                 }
//             },
//             message: {
//                 presence: {allowEmpty: false, message: "is required"}
//             }
//         };
//
//         // Get the form values
//         let formValues = {
//             full_name: document.getElementById("full_name").value,
//             organization: document.getElementById("organization").value,
//             email: document.getElementById("email").value,
//             tel: document.getElementById("phone").value,
//             message: document.getElementById("message").value
//         };
//
//         // Validate the form data
//         let errors = validate(formValues, constraints);
//
//         // Clear previous error messages
//         document.querySelectorAll('.error-message').forEach(function(el) {
//             el.innerHTML = "";
//         });
//
//         // If there are errors, prevent form submission and show the errors under each field
//         if (errors) {
//             event.preventDefault(); // Prevent form submission
//
//             // Display the error messages under each field
//             Object.keys(errors).forEach(function(field) {
//                 let fieldErrors = errors[field];
//                 let fieldElement = document.getElementById(field);
//
//                 // Find or create an error message element for the field
//                 let errorElement = fieldElement.parentElement.querySelector('.error-message');
//                 if (!errorElement) {
//                     errorElement = document.createElement('div');
//                     errorElement.classList.add('error-message');
//                     fieldElement.parentElement.appendChild(errorElement);
//                 }
//
//                 // Display the first error message for the field
//                 errorElement.innerHTML = fieldErrors[0];
//             });
//         } else {
//
//             document.getElementById('contact').classList.add('loading');
//
//             let formData = new FormData(document.getElementById("contactForm"));
//
//             fetch('/api/form/contact', {
//                 method: 'POST',
//                 body: formData
//             })
//                 .then(response => response.json())
//                 .then(data => {
//                     document.getElementById('contact').classList.remove('loading');
//
//                     // If submission is successful
//                     if (data.status === 'success') {
//                         // Show success message
//                         document.getElementById("contactForm").style.display = "none";
//                         var successMessage = document.getElementById('success-message');
//                         successMessage.innerHTML = data.message;
//
//                         document.getElementById("contactForm").reset();
//                     } else {
//                         // If errors, show error message(s)
//                         var errorMessage = document.getElementById('success-message');
//                         errorMessage.innerHTML = data.message.join("<br>");
//                     }
//                 })
//                 .catch(error => {
//                     document.getElementById('contact').classList.remove('loading');
//                     console.error('Form submission error:', error);
//                     // Handle and display the error
//                     var errorMessage = document.getElementById('success-message');
//                     errorMessage.innerHTML = "There was an error submitting the form. Please try again.";
//                     errorMessage.classList.add('error');
//                 });
//         }
//     });
// });



import Pristine from 'pristinejs/dist/pristine';

// const script = document.createElement('script');
// script.src = 'https://www.google.com/recaptcha/api.js?render=explicit&onload=onRecaptchaLoadCallback';
// document.body.appendChild(script);
//
// function onRecaptchaLoadCallback() {
//     // Remove all elements with the class 'inline-badge'
//     document.querySelectorAll('.inline-badge').forEach((element) => {
//         element.remove();
//     });
//
//     // Iterate through all elements with the class 'holder'
//     document.querySelectorAll('.holder').forEach((holder) => {
//         const id = holder.getAttribute('data-unique-id');
//         // eslint-disable-next-line no-param-reassign
//         holder.innerHTML = `<div class="inline-badge" id="inline-${id}"></div>`;
//
//         // eslint-disable-next-line no-undef
//         const clientId = grecaptcha.render(`inline-${id}`, {
//             sitekey: '6LftR3YqAAAAANE0Xl0W7TbwT1Hioeixst1RaoMy',
//             badge: 'inline',
//             size: 'invisible'
//         });
//
//         // eslint-disable-next-line no-undef
//         grecaptcha.ready(() => {
//             // eslint-disable-next-line no-undef
//             grecaptcha
//                 .execute(clientId, {
//                     action: 'submission'
//                 })
//                 .then((token) => {
//                     const form = holder.closest('form');
//                     const captchaTokenField =
//                         form.querySelector('.captchaToken');
//                     captchaTokenField.value = token;
//                 });
//         });
//     });
//
//     // Set tabindex of iframe inside elements with the class 'grecaptcha-logo' to -1
//     document.querySelectorAll('.grecaptcha-logo iframe').forEach((iframe) => {
//         iframe.setAttribute('tabindex', '-1');
//     });
// }
//
// // Call onRecaptchaLoadCallback every 150000ms (2.5 minutes)
// setInterval(onRecaptchaLoadCallback, 150000);

const pristineConfig = () => ({
    classTo: 'form-group',
    errorClass: 'has-danger',
    successClass: 'has-success',
    errorTextParent: 'form-group',
    errorTextTag: 'div',
    errorTextClass: 'text-help'
});

class Form {
    constructor(element) {
        this.element = element;
        this.formElement = element.querySelector('form');
        this.formFieldsWrapper = element.querySelector('.form-fields-wrapper');
        this.pristine = new Pristine(this.formElement, pristineConfig());
        this.loadingOverlay = element.querySelector('.loading-overlay');
        this.messageWrapper = element.querySelector('.message-wrapper');
        this.message = element.querySelector('.message');
        this.backToFormElement = element.querySelector('.back-to-form');
        this.thankYouMessage = this.message.innerHTML;
        this.conditionalTriggers = element.querySelectorAll(
            '[data-conditional-trigger]'
        );
    }

    init() {
        this.formElement.addEventListener('submit', this.onSubmit.bind(this));
        if (this.backToFormElement) {
            this.backToFormElement.addEventListener(
                'click',
                this.backToForm.bind(this)
            );
        }
        this.conditionalTriggers.forEach((trigger) => {
            trigger.addEventListener(
                'change',
                this.onConditionalTriggerChange.bind(this)
            );
        });
    }

    // eslint-disable-next-line class-methods-use-this
    onConditionalTriggerChange(e) {
        const { currentTarget } = e;
        const triggerName = currentTarget.getAttribute(
            'data-conditional-trigger'
        );
        const selectedValue = currentTarget.value;

        // Find and hide all conditional fields associated with this trigger
        const conditionalFields = this.element.querySelectorAll(
            `[data-if-trigger="${triggerName}"]`
        );
        conditionalFields.forEach((field) => {
            // eslint-disable-next-line no-param-reassign
            field.style.display = 'none';
            const required = field.querySelectorAll('[required]');
            required.forEach((req) => {
                req.removeAttribute('required');
            });
        });

        // Show the field matching the selected value
        const targetField = this.element.querySelector(
            `[data-if-trigger="${triggerName}"][data-if-value="${selectedValue}"]`
        );

        if (targetField) {
            targetField.style.display = 'block';
            targetField.querySelectorAll('[data-required]').forEach((req) => {
                req.setAttribute('required', '');
            });
        }

        this.pristine.reset();
        this.pristine.destroy();
        this.pristine = new Pristine(this.formElement, pristineConfig());
    }

    async onSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        const valid = this.pristine.validate();

        if (!valid) return;

        this.showLoading();

        const redirect = this.formElement.getAttribute('data-redirect');
        const formData = new FormData(this.formElement);
        const formAction = this.formElement.getAttribute('action');
        const formMethod = this.formElement.getAttribute('method');

        try {
            const response = await fetch(formAction, {
                method: formMethod,
                body: formData
            });
            const data = await response.json();
            if (data.status === 'success') {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'contact_form_submission',
                    category: 'Form Submission',
                    label: `Form Submission on ${window.location.href}`
                });
                this.formElement.reset();
                if (redirect) {
                    window.location.href = redirect;
                } else {
                    this.showMessage(data.thankYouMessage || this.thankYouMessage);
                }
            } else {
                this.showMessage(
                    Array.isArray(data.message)
                        ? data.message.join('<br>')
                        : data.message
                );
                console.error('Form submission error:', data);
            }
        } catch (error) {
            console.error('Form submission error:', error);
        }

        this.hideLoading();
    }

    makeFormFieldsUnfocusable() {
        const focusableElements = this.formElement.querySelectorAll(
            'button, input, select, textarea'
        );
        focusableElements.forEach((element) => {
            element.setAttribute('tabindex', '-1');
        });
    }

    showLoading() {
        this.loadingOverlay.style.visibility = 'visible';
        this.element.setAttribute('aria-busy', 'true');
    }

    hideLoading() {
        this.loadingOverlay.style.visibility = 'hidden';
        this.element.removeAttribute('aria-busy');
    }

    showMessage(message) {
        this.message.innerHTML = message;
        this.messageWrapper.style.visibility = 'visible';
        const firstFocusable = this.getFirstFocusableElement(
            this.messageWrapper
        );
        if (firstFocusable) firstFocusable.focus();
        this.removeFormFieldsFromTabIndex();
    }

    hideMessage() {
        this.messageWrapper.style.visibility = 'hidden';
        this.addFormFieldsToTabIndex();
    }

    // eslint-disable-next-line class-methods-use-this
    removeFormFieldsFromTabIndex() {
        const focusable = this.getFocusableElements(this.formFieldsWrapper);
        focusable.forEach((element) => {
            element.setAttribute('tabindex', '-1');
        });
    }

    addFormFieldsToTabIndex() {
        const focusable = this.getFocusableElements(this.formFieldsWrapper);
        focusable.forEach((element) => {
            element.removeAttribute('tabindex');
        });
    }

    // eslint-disable-next-line class-methods-use-this
    getFocusableElements(parentElement) {
        const focusableSelectors = [
            'a[href]',
            'button:not([disabled])',
            'input:not([type="hidden"]):not([disabled]):not(.form-honeybear)',
            'textarea:not([disabled])',
            'select:not([disabled])',
            'details',
            '[tabindex]:not([tabindex="-1"])'
        ];

        return parentElement.querySelectorAll(focusableSelectors.join(', '));
    }

    // eslint-disable-next-line class-methods-use-this
    getFirstFocusableElement(parentElement) {
        const focusableElements = this.getFocusableElements(parentElement);
        return focusableElements.length > 0 ? focusableElements[0] : null;
    }

    backToForm() {
        this.hideMessage();
        // eslint-disable-next-line no-undef
        onRecaptchaLoadCallback();
        const firstFocusable = this.getFirstFocusableElement(this.formElement);
        if (firstFocusable) firstFocusable.focus();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const forms = document.querySelectorAll('.custom-form');
    forms.forEach((element) => {
        const form = new Form(element);
        form.init();
    });
});
